import { useTranslation } from "react-i18next";
import { useCreatedResellers } from "@/api/reseller-manager/queries";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";

interface ResellerSelectProps {
	value: number | null;
	onChange: (value: number | null) => void;
	includeAllOption?: boolean;
	placeholder?: string;
	disabled?: boolean;
}

export function ResellerSelect({
	value,
	onChange,
	includeAllOption = false,
	placeholder,
	disabled = false,
}: ResellerSelectProps) {
	const { t } = useTranslation();
	const { data, isLoading } = useCreatedResellers({ page_size: 100 });
	const resellers = data?.results ?? [];

	const ALL_VALUE = "__all__";
	const selectValue = value === null ? ALL_VALUE : String(value);

	function handleChange(raw: string) {
		onChange(raw === ALL_VALUE ? null : Number(raw));
	}

	return (
		<Select
			value={selectValue}
			onValueChange={handleChange}
			disabled={disabled || isLoading}
		>
			<SelectTrigger className="w-full min-w-[180px]">
				<SelectValue
					placeholder={placeholder ?? t("dashboard.resellerFilter.placeholder")}
				/>
			</SelectTrigger>
			<SelectContent>
				{includeAllOption && (
					<SelectItem value={ALL_VALUE}>
						{t("dashboard.resellerFilter.all")}
					</SelectItem>
				)}
				{resellers.map((r) => (
					<SelectItem key={r.id} value={String(r.id)}>
						{r.company_name}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
}
